import { merge } from 'ramda'
import { ACTION_TYPES } from './actions'

const defaultState = {
  clickMap: []
}

const playbooks = (state = defaultState, action) => {
  switch (action.type) {
    case ACTION_TYPES.fetchSignatureClickMapSuccess:
      return merge(state, {clickMap: action.clickMap } )

    default:
      return state
  }
}

export default playbooks
